module.exports = require('./container');



/** WEBPACK FOOTER **
 ** ./src/components/container/index.js
 **/